import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Product } from '../types';
import { TextButton } from './TextButton';
import { smsMessages } from '../utils/sms';
import { guarantees } from '../data/site';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const featured = Boolean(product.featured);
  return <article className={`flex h-full flex-col overflow-hidden rounded-2xl bg-paper transition-shadow duration-200 ease-smooth ${featured ? 'ring-1 ring-aqua-500 shadow-lift' : 'ring-1 ring-ink-950/8 shadow-card hover:shadow-lift'}`} data-id="element-207" data-mp="kclly7ivifcd">
      <div className="relative aspect-[16/10] overflow-hidden bg-canvas" data-id="element-208" data-mp="tb6x3hm0ms34">
        <img src={product.image} alt="" className="h-full w-full object-cover" loading="lazy" data-id="element-209" data-mp="ybupa6lzdeyx" />
        {featured && <span className="absolute left-4 top-4 rounded-full bg-aqua-600 px-3 py-1 text-[11px] font-medium uppercase tracking-[0.12em] text-white" data-id="element-210" data-mp="302y12z7lwzl2">
            Most installed
          </span>}
      </div>

      <div className="flex flex-1 flex-col p-6" data-id="element-211" data-mp="3gz2oknimd4p7">
        <h3 className="font-display text-xl font-semibold tracking-tight text-ink-950" data-id="element-212" data-mp="3gyawvns57r47">
          {product.name}
        </h3>
        <p className="mt-1.5 text-sm text-ink-600" data-id="element-213" data-mp="37zz5hjjgcpap">{product.capacity}</p>

        {product.financing && <p className="mt-4 inline-flex w-fit rounded-full bg-aqua-50 px-3 py-1 text-[12px] font-medium text-aqua-700 ring-1 ring-aqua-200" data-id="element-214" data-mp="8klsge5v6kyi">
            {product.financing}
          </p>}

        <p className="mt-5 text-sm leading-relaxed text-ink-700" data-id="element-215" data-mp="3vo8okdpa6yy5">
          {product.description}
        </p>

        <ul className="mt-6 space-y-2.5 border-t border-ink-950/8 pt-6" data-id="element-216" data-mp="3qovr6z0sa9hb">
          {guarantees.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] text-ink-700" data-id="element-217" data-mp="2kbfyd7c52ik7">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-aqua-600" aria-hidden="true" data-id="element-218" data-mp="2fa0dbf9yoc1t" />
              {item}
            </li>)}
        </ul>

        <div className="mt-auto pt-7" data-id="element-219" data-mp="2lqibb3xguvhs">
          <TextButton message={smsMessages.product(product.name, product.capacity)} variant={featured ? 'primary' : 'ink'} size="md" className="w-full" data-id="element-220" data-mp="27r98r726nzwa">
            Text for Price
          </TextButton>
          <p className="mt-3 text-center text-xs text-ink-400" data-id="element-221" data-mp="1xzwhoho7ldrb">
            Opens your messages app &mdash; no forms, no waiting
          </p>
        </div>
      </div>
    </article>;
}